export default __webpack_public_path__ + "static/media/oklahoma.30a615ea.jpg";